<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="enterpriseForm" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="企业名称" prop="EnterpriseInfo.enterpriseName">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.enterpriseName"
                      :clearable="true" placeholder="企业名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="技术领域" prop="EnterpriseInfo.technologyField">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.technologyField"
                      :clearable="true" placeholder="技术领域"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系方式" prop="EnterpriseInfo.contactInfo">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.contactInfo"
                      :clearable="true" placeholder="联系方式"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="EnterpriseInfo.remark">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.remark"
                      type="textarea"
                      :autosize="{minRows: 1, maxRows: 1}"
                      :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="位置" prop="EnterpriseInfo.location">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.location"
                      :clearable="true" placeholder="位置"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize"
                      :disabled="(mode === 'update' && !checkPermCodeExist('enterpriseInfo:all'))"
                      @click="onSaveClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { EnterpriseInfoController, DictionaryController } from '@/api';

export default {
  name: 'enterpriseForm',
  props: {
    id: {
      default: undefined
    },
    mode: {
      type: String,
      default: 'update', // 'add' or 'update'
      validator: (value) => ['add', 'update'].includes(value)
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        EnterpriseInfo: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          enterpriseName: undefined,
          technologyField: undefined,
          contactInfo: undefined,
          remark: undefined,
          location: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'EnterpriseInfo.enterpriseName': [
          {required: true, message: '请输入企业名称', trigger: 'blur'}
        ],
        'EnterpriseInfo.technologyField': [
          {required: true, message: '请输入技术领域', trigger: 'blur'}
        ]
      },
      enterpriseForm: {
        formFilter: {},
        formFilterCopy: {},
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 刷新表单数据
     */
    refreshEnterpriseForm (reloadData = false) {
      if (this.mode === 'add') {
        this.resetFormData();
        this.enterpriseForm.isInit = true;
      } else {
        this.loadEnterpriseInfoData().then(res => {
          this.enterpriseForm.isInit = true;
        }).catch(e => {});
      }
    },
    /**
     * 保存
     */
    onSaveClick () {
      this.$refs.enterpriseForm.validate((valid) => {
        if (!valid) return;
        let params = {
          enterpriseInfoDto: {
            ...(this.mode === 'add' ? {
              enterpriseName: this.formData.EnterpriseInfo.enterpriseName,
              technologyField: this.formData.EnterpriseInfo.technologyField,
              contactInfo: this.formData.EnterpriseInfo.contactInfo,
              remark: this.formData.EnterpriseInfo.remark,
              location: this.formData.EnterpriseInfo.location
            } : this.formData.EnterpriseInfo)
          }
        };

        const savePromise = this.mode === 'add'
          ? EnterpriseInfoController.add(this, params)
          : EnterpriseInfoController.update(this, params);

        savePromise.then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEnterpriseForm(true);
    },
    /**
     * 获取企业信息详细信息
     */
    loadEnterpriseInfoData () {
      return new Promise((resolve, reject) => {
        if (!this.formData.EnterpriseInfo.isDatasourceInit) {
          if (
            this.id == null
          ) {
            this.resetFormData();
            reject();
            return;
          }
          let params = {
            id: this.id
          };
          EnterpriseInfoController.view(this, params).then(res => {
            this.formData.EnterpriseInfo = {...res.data, isDatasourceInit: true};
            resolve();
          }).catch(e => {
            reject();
          });
        } else {
          this.formData.EnterpriseInfo.isDatasourceInit = true;
          resolve();
        }
      });
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        EnterpriseInfo: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          enterpriseName: undefined,
          technologyField: undefined,
          contactInfo: undefined,
          remark: undefined,
          location: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshEnterpriseForm();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
